import { Schema } from "effect";

export const SocialProfileSchema = Schema.Struct({
  username: Schema.String,
  displayName: Schema.String,
  primaryChartId: Schema.String,
  allowCompatibility: Schema.Boolean,
  isPublic: Schema.optional(Schema.Boolean),
  profilePhoto: Schema.optional(Schema.String),
});

export type SocialProfile = typeof SocialProfileSchema.Type;

export const ProfileSettingsResponseSchema = Schema.Struct({
  profile: Schema.NullOr(SocialProfileSchema),
});

export type ProfileSettingsResponse = typeof ProfileSettingsResponseSchema.Type;

export const SaveSocialProfileRequestSchema = Schema.Struct({
  username: Schema.String,
  allowCompatibility: Schema.Boolean,
  isPublic: Schema.optional(Schema.Boolean),
});

export type SaveSocialProfileRequest = typeof SaveSocialProfileRequestSchema.Type;

export function decodeSaveSocialProfileRequest(value: unknown): SaveSocialProfileRequest {
  try {
    return Schema.decodeUnknownSync(SaveSocialProfileRequestSchema)(value);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(`Invalid social profile request: ${message}`);
  }
}
